import Checkbox, { CheckboxProps } from 'components/commercetools-ui/atoms/checkbox';
import { ProductDetailsProps } from '..';
import Modal, { ModalProps } from '../../../modal';
import { useState } from 'react';
import { renderTextWithLineBreaks } from 'helpers/utils/textFormatter';
import QuestionMarkIcon from '../../../../../icons/question-mark';
import { XMarkIcon } from '@heroicons/react/24/solid';
import Image from 'components/commercetools-ui/atoms/image';

type WirebrushModalProps = ProductDetailsProps['wirebrushModal'] & ModalProps;

export const WirebrushModal = (props: WirebrushModalProps) => {
  return (
    <Modal
      {...props}
      isOpen={props.isOpen}
      preventScroll
      style={{ content: { background: 'white', width: '650px' /* , maxHeight: '600px' */ } }}
      className="md:max-h-600 max-md:!fixed max-md:!inset-0 max-md:!bottom-0 max-md:!transform-none max-md:overflow-y-scroll"
      contentLabel={props.title}
    >
      <div className="px-32 py-34">
        <div className="flex items-center justify-between">
          <h1 className="body-text-large mr-16 font-medium text-text-primary">{props.title}</h1>
          <button onClick={props.onRequestClose} aria-label={props.closeButtonAriaLabel ?? 'Close'}>
            <XMarkIcon className="size-24 text-icon-primary hover:cursor-pointer" strokeWidth={1} aria-hidden />
          </button>
        </div>
        {renderTextWithLineBreaks(props.text, 'mt-34')}
        <div className="mt-24 flex flex-col gap-24 md:flex-row">
          {props.images?.map((img, index) => (
            <div className="flex flex-col gap-y-8" key={`image-${index}-${img.name}`}>
              <h2 className="body-text-small font-medium text-text-primary">{img.name}</h2>
              <Image {...img.image} className="md:max-h-187" />
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export const Wirebrush = ({
  checkbox,
  modal,
  className = '',
  iconAriaLabel = 'Open wirebrush description',
}: {
  checkbox: CheckboxProps;
  modal: Omit<WirebrushModalProps, 'isOpen' | 'onRequestClose'>;
  iconAriaLabel?: string;
  className?: string;
}) => {
  const [isWirebrushModalOpen, setIsWirebrushModalOpen] = useState<boolean>(false);

  return (
    <div className={`flex items-center gap-x-4 ${className}`}>
      <Checkbox {...checkbox} />
      <button
        onClick={() => setIsWirebrushModalOpen(!isWirebrushModalOpen)}
        className="cursor-pointer"
        aria-label={iconAriaLabel}
      >
        <QuestionMarkIcon ariaHidden />
      </button>
      {modal && (
        <WirebrushModal
          {...modal}
          isOpen={isWirebrushModalOpen}
          onRequestClose={() => setIsWirebrushModalOpen(false)}
        />
      )}
    </div>
  );
};
